import {collection, getDocs} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';
import {fail, logError, ok, toConfigError} from './apiHelpers';

/**
 * Fetch all available Modbus templates from the `modbusTemplates` Firestore collection.
 * Returns { ok, data: { templateId: string }[] } on success.
 */
export const getModbusTemplateIds = async () => {
  try {
    const snap = await getDocs(collection(db, 'modbusTemplates'));
    const ids = [];
    snap.forEach((doc) => ids.push(doc.id));
    return ok(ids);
  } catch (error) {
    const errorInfo = toConfigError(error, 'CONFIG_LOAD_FAILED');
    logError('getModbusTemplateIds', errorInfo);
    return fail(errorInfo);
  }
};

